module.exports = __webpack_public_path__ + "img/Like.952d8e43.svg";